export const localJobConstants = {
    SET_JOB_EDITABLE: 'SET_JOB_EDITABLE',
    SET_JOB_FILES_EDITABLE: 'SET_JOB_FILES_EDITABLE'
};
